import React, { useState, useEffect } from 'react';
import { makeStyles, Paper } from '@material-ui/core';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@mui/material/Divider';
import { FilePicker } from 'react-file-picker';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BarWave from "react-cssfx-loading/lib/BarWave";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';

import FormHelperText from '@mui/material/FormHelperText';


import CancelIcon from '@mui/icons-material/Cancel';
import { dataService } from '../../services/data/data.service'
import { HubConnectionBuilder } from '@microsoft/signalr';
import MenuItem from '@mui/material/MenuItem';



export default function ImportExcelModal(props) {
    const classes = useStyles();
    const [excelToProcess, setExcelToProcess] = useState(null);
    const [transforming, setTransforming] = useState(false);
    const [processedExcel, setProcessedExcel] = useState(null);
    const [transformFailed, setTransformFailed] = useState(false);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [newSelectedFile, setFile] = useState(null);
    const [years, setYears] = useState([]);
    const copyExcelToDestination = async (file) => {
        setFile(file);
        let tempFileName = file.name;

        var blob = file.slice(0, file.size);
        if (selectedYear !== null){
            createFile(blob, tempFileName, selectedYear);
        }

    }
    
    const handleDateChange = (event) => {
        // setFirstLevel(true);
        setSelectedYear(event.target.value);
        if(newSelectedFile !== null){
            var blob = newSelectedFile.slice(0, newSelectedFile.size);
            let tempFileName = newSelectedFile.name;
            createFile(blob, tempFileName, event.target.value);

        }
        // getReportdataByCityAndYear(selectedCities, event.target.value);
    };

    const createFile = (blob, file, year) => {
   
        var today = new Date();
        var time = today.getHours().toString() + today.getMinutes().toString() + today.getSeconds().toString();
        let newFile = new File([blob], props.user.userid + '^_^' + props.customerId + '^_^' + year + '^_^' +time +  '^_^' + file);
        console.log(newFile);
        setExcelToProcess(newFile);

    }
    const transformExcel = () => {
        setTransforming(true);
        dataService.uploadExcel(excelToProcess).then();
    }

    useEffect(() => {

        let year = new Date().getFullYear();
        let tempyears = [];

        for (let i = year - 5; i < year + 2; i++) {
            tempyears.push(i);
        }
        setYears(tempyears);
        const newHubConnection = new HubConnectionBuilder()
            .withUrl(props.appSettings.DATATRANSFORM_HUB_URL)
            .withAutomaticReconnect()
            .build();


        newHubConnection.on('ReceiveMessage', message => {
            console.log("From transform hub: ")
            if (!message.succeeded) {
                setTransformFailed(true);
                setTransforming(false);
                props.handleCloseImport();

            } else {
                //setProcessedFileDownloadable(message.filename)
                setTransforming(false);
                props.handleCloseImport();
                location.reload();
            }
        });
        newHubConnection.start().then(_ => {
            console.log('Transform connected!');
        }).catch(e => console.log('Transform connection failed: ', e));
    }, [props.appSettings.DATATRANSFORM_HUB_URL])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    return (
        <div>

            <Dialog onClose={props.handleCloseImport} aria-labelledby="customized-dialog-title" open={props.open} maxWidth={'lg'}
            >
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <p className={classes.deleteText}>{"Importeer Excel"}</p>
                        <Divider />



                        <div className={classes.yearSelector}>
                            <b style={{ marginRight: '15px' }}>Stap 1: </b> Selecteer het jaartal waartoe de data zal behoren:
                            <div>

                                <TextField
                                    id="select"
                                    label={"Jaartal"}
                                    select
                                    value={selectedYear}
                                    onChange={handleDateChange}
                                    MenuProps={{ style: { maxHeight: 400, disableScrollLock: true, } }}
                                    className={classes.yearDropdown}

                                >
                                    {
                                        years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                    }
                                </TextField>

                            </div>

                        </div>
                        <div className={classes.filePickerBlock}>
                            <b style={{ marginRight: '15px' }}>Stap 2: </b> Upload een bestand en maak zo nieuwe registraties

                            <FilePicker
                                className={classes.filePicker}
                                extensions={['xlsx']}
                                mode="pickAndStore"
                                onChange={FileObject => copyExcelToDestination(FileObject)}
                                onError={errMsg => (console.log(errMsg))}>
                                <button className={classes.importButton}>
                                    {excelToProcess !== null ?
                                        <CheckCircleIcon sx={{ fontSize: 35 }} className={classes.circleDone}></CheckCircleIcon>
                                        : ''}

                                    <div>
                                        <img className={classes.img} alt={"excel"} src={process.env.PUBLIC_URL + '/img/excelIcon.svg'}></img>
                                    </div>
                                </button>
                            </FilePicker>
                        </div>
                        <div className={classes.buttonRow}>
                            <Button autoFocus variant="outlined" onClick={props.handleCloseImport} color="primary">
                                {"Annuleer"}
                            </Button>

                            {/* onClick={() => props.handleSave()} */}
                            <Button className={classes.combineButton} onClick={() => transformExcel()} variant="contained" color="primary" disabled={excelToProcess === null ? true : false}>
                                {"Importeer"}
                            </Button>
                        </div>

                    </div>
                    {transforming === true ?
                        <div className={classes.overlay}>
                            <React.Fragment>
                                <div className={classes.transformingOverlay}>
                                </div>
                                <div className={classes.centerLoading}>
                                    <div className={classes.transforming}>{"Eventjes geduld..."}</div>
                                    <BarWave color="#1F8FA5" width="100px" height="40px"></BarWave>
                                </div>

                            </React.Fragment>

                        </div>
                        : <React.Fragment></React.Fragment>}
                </DialogContent>

            </Dialog>
            {/*  */}

            {/* } */}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    spacer15: {
        height: '15px'
    },
    thead: {
        border: '1px solid black',
        marginBottom: '10px',
    },
    table: {
        border: '1px solid black',
        marginBottm: '15px',
    },
    tableRow: {
        border: '1px solid black'

    },
    tableData: {
        border: '1px solid #1F8FA5',
        backgroundColor: '#1F8FA5',
        color: 'white',
    },
    paper: {
        padding: '50px',
        margin: "50px",
        height: '70%'
    },

    dialog: {
        width: "700px",
        paddingLeft: "30px",
        paddingRight: "30px",
        paddingTop: "15px",
        paddingBottom: "15px",
        justifyContent: "center",
        textAlign: "center"
    },
    filePicker: {
        border: '0px',
        backgroundColor: "#1F8FA5 !important",

    },

    deleteIcon: {
        fontSize: "100pt",
        color: "gray",
        width: "100px !important",
        height: "100px !important",
    },

    deleteText: {
        fontSize: "20pt"
    },

    deleteTexsmall: {
        fontSize: "14pt"
    },
    buttonRow: {
        marginTop: '25px',
        justifyContent: 'space-around',
        display: 'flex',
    },
    combineButton: {
        marginLeft: '20px',
        backgroundColor: "#1F8FA5 !important",
        margin: "10px"
    },
    importButton: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1F8FA5 !important",
        width: "100px",
        height: "100px",
        margin: "5px 25px",
        color: "white",
        textDecoration: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative",
        marginBottom: "15px",
        '&:hover': {
            textDecoration: 'none !important',
            color: "white",
        }

    },
    circleDone: {
        position: "absolute",
        top: "-25px",
        right: "-20px",
        color: "green",

    },
    circleFailed: {
        position: "absolute",
        top: "-30px",
        right: "-20px",
        color: "red",

    }, img: {
        color: "white",
        width: "50px"
    }, filePickerBlock: {
        marginTop: '25px',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    yearSelector: {
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'

    },
    yearDropdown: {
        marginLeft: '15px !important',
        width: '150px',
        fontSize: '20pt',
        fontFamily: "Segoe UI Light",
    },
    transformingOverlay: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: 'black',
        opacity: "0.8",
        width: "100%",
        height: "100%",
        zIndex: "10",
        position: "fixed",
        top: "0",
        left: "0",
        justifyContent: "center",
        alignItems: "center",
    },
    centerLoading: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "11",
        position: "relative",
        bottom: "22%"

    },
    overlay: {
        top: '0',
        left: '0',
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: '1001',
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'center',
    },

}));